import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { LocalStorageService } from '@core/services/local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanActivate {
  constructor(
    private localStorageService: LocalStorageService,
    private router: Router
  ) { }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const user = this.localStorageService.getItem('user');

    if (!user || !user.codeProfile) {
      this.router.navigateByUrl('/login');
      return false;
    }

    const role: string = user.codeProfile;
    const allowedRoles: Record<string, string[]> = {
      SA: [
        'dashboard',
        'Nuevo-cliente',
        'Reportes-reconocimientos',
        'Nuevo-usuario-admin',
        'Credenciale-usuario',
        'Avances',
        'Pedido-sugerido',
        'Gestion-vendedores',
        'Producto-sugerido',
        'Precios-y-promociones',
        'Reporte-aliados',
        'Clientes-aliados',
        'reportes',
        'notificaciones',
        'fotos-productos',
        'banner',
        'cc-report',
        'hobs',
        'mas',
        'Alicorp-way',
        'banners-home',
      ],
      AD: [
        'dashboard',
        'Nuevo-cliente',
        'Reportes-reconocimientos',
        'Credenciale-usuario',
        'Avances',
        'Pedido-sugerido',
        'Gestion-vendedores',
        'Producto-sugerido',
        'Precios-y-promociones',
        'Reporte-aliados',
        'Clientes-aliados',
        'reportes',
        'notificaciones',
        'fotos-productos',
        'banner',
        'cc-report',
        'hobs',
        'mas',
        'Alicorp-way',
        'banners-home',
      ],
      RR: [
        'Avances',
        'Reportes-reconocimientos',
        'Reporte-aliados',
        'Pedido-sugerido',
        'Precios-y-promociones',
        'notificaciones',
        'reportes',
        'Alicorp-way',
      ],
      RK: [
        'Precios-y-promociones',
        'Reportes-reconocimientos',
        'Reporte-aliados',
        'fotos-productos',
        'banner',
        'Alicorp-way',
         'notificaciones',
      ],
      NO: [
        'notificaciones',
        'banners-home',
      ],
    };

    const allowedUrls = allowedRoles[role];
    const url = route.routeConfig?.path;
    if (allowedUrls && url && allowedUrls.includes(url)) {
      return true;
    }

    // Redirección por rol
    switch (role) {
      case 'AD':
      case 'SA':
        this.router.navigateByUrl('/admin/dashboard');
        break;
      case 'RR':
        this.router.navigateByUrl('/admin/Avances');
        break;
      case 'RK':
        this.router.navigateByUrl('/admin/Precios-y-promociones');
        break;
      case 'NO':
        this.router.navigateByUrl('/admin/notificaciones');
        break;
      default:
        this.router.navigateByUrl('/login');
    }

    return false;
  }
}
